'use client';

import CommonErrorPage from '~/components/common/appRouter/CommonErrorPage';

type OwnProps = {
  error: Error & { digest?: string };
};

export default function Error({ error }: OwnProps) {
  return <CommonErrorPage page="vdp" error={error} inCarvanaLayout />;
}
